// extracted by mini-css-extract-plugin
export default {"container":"ErrorPage_container__W6uAO"};